@use "styles/abstracts/variables" as v;
@use "styles/abstracts/mixins/typography" as t;

.tooltipContainersList {
  background-color: v.$palette-gray-900;
  position: relative;
  color: v.$palette-white;
  padding: 8px 16px;
  border-radius: 6px;
  z-index: v.$z-index-containers-list-tooltip;

  &::after {
    content: "";
    left: calc(50% - 5px);
    bottom: -7px;
    position: absolute;
    background-color: v.$palette-gray-900;
    width: 15px;
    height: 15px;
    border-radius: 2px;
    rotate: 135deg;
  }
}

.containerItem {
  @include t.text(14px, 22px, 400);
  text-align: left;
}

.containerAmount {
  @include t.text(12px, 20px, 500);
  padding: 2px 10px;
  border-radius: 24px;
  background-color: v.$palette-future-accent;
  color: v.$palette-blue;
  display: flex;
  align-items: center;

  .icon {
    cursor: pointer;
    margin-left: 9px;
    path {
      fill: v.$palette-blue;
    }
  }
}

